import { Injectable } from '@angular/core';
import { DEFAULT_LANGUAGE, SESSION_TRANSLATIONS, SUPPORTED_LANGUAGES, SupportedLanguage } from '../i18n/session-translations';

@Injectable({providedIn: 'root'})
export class SessionLanguageService {

  private language: SupportedLanguage = DEFAULT_LANGUAGE;

  applyLanguage(languageParam: string | undefined | null): void {
    this.language = SUPPORTED_LANGUAGES.includes(languageParam as SupportedLanguage)
      ? languageParam as SupportedLanguage
      : DEFAULT_LANGUAGE;
  }

  translate(key: string): string {
    return SESSION_TRANSLATIONS[this.language][key] ?? key;
  }

  get isRTL(): boolean {
    return this.language === 'he';
  }

  get direction(): 'ltr' | 'rtl' {
    return this.isRTL ? 'rtl' : 'ltr';
  }
}
